import React from 'react';
import { Link } from 'react-router-dom';

const FooterSection: React.FC = () => {
  return (
    <footer
      style={{
        display: 'flex',
        justifyContent: 'center',
        background: '#000',
        color: '#fff',
        padding: '40px 20px',
        direction: 'rtl',
      }}
    >
      <div
        style={{
          maxWidth: 1200,
          width: '100%',
          display: 'flex',
          flexWrap: 'wrap',
          rowGap: '2em',
          justifyContent: 'space-between',
        }}
      >
        {/* بخش اول - لوگو و توضیح */}
        <div style={{ flex: '1 1 300px', display: 'flex', flexDirection: 'column', gap: 8 }}>
          <a href="/" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <img src="logo512.png" alt="دپ تک" width={36} height={36} />
            <h2 style={{ margin: 0 }}>دانش پردازش پیشرو تک</h2>
          </a>
          <div>ارائه دهنده خدمات هوش مصنوعی</div>
          <div style={{ opacity: 0.7 }}>© 2024-2025 دپ تک</div>
        </div>

        {/* بخش دوم - ویژگی‌ها */}
        <div style={{ flex: '1 1 200px', display: 'flex', flexDirection: 'column', gap: 8 }}>
          <div style={{ fontWeight: 'bold' }}>ویژگی‌ها</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <a href="/" target="_blank" style={{ color: '#fff', textDecoration: 'none' }}>ویژگی‌های جدید</a>
            <Link to="/pricing" style={{ color: '#fff', textDecoration: 'none' }}>قیمت‌ها</Link>
          </div>
        </div>

        {/* بخش سوم - درباره دپ تک */}
        <div style={{ flex: '1 1 200px', display: 'flex', flexDirection: 'column', gap: 8 }}>
          <div style={{ fontWeight: 'bold' }}>دپ تک</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <Link to="/about" style={{ color: '#fff', textDecoration: 'none' }}>درباره ما</Link>
            <Link to="/contact" style={{ color: '#fff', textDecoration: 'none' }}>ارتباط با ما</Link>
          </div>
        </div>

        {/* بخش چهارم - اطلاعات تماس */}
        <div style={{ flex: '1 1 250px', display: 'flex', flexDirection: 'column', gap: 8 }}>
          <div style={{ fontWeight: 'bold' }}>اطلاعات تماس</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4, fontSize: '0.85rem' }}>
            <span>📞 02532802756 | 09053967532</span>
            <span>📍 استان قم، شهر قم، امام خمینی، کوچه عابدی، بن‌بست بن بهرامی، طبقه ۱</span>
            <span>🧾 کد پستی: 3719986937</span>
            <span>✉️ info@dptek.ir</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
